export const showClearValue = (value, indices, canEdit, question, isCustom) => {
  return (
    canEdit &&
    !isCustom &&
    indices.length > 1 &&
    value.filter(x => x.templateQuestionId === question.id).length > 0
  )
}
